import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

const fetchKpisObjetivo = async (user_id, token, objetivoId) => {
  const url = `${api_host}/reporte/online/indicadores/getDisponibility/?user=${user_id}&key=${api_auth}&objetivoId=${objetivoId}&t=d&token=${token}&_=${new Date().getTime()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useKpisObjetivo = (objetivoId, options = {}) => {
  const {user, token} =getApiKeys()

  return useQuery({
    queryKey: ['kpisObjetivo', user, objetivoId],
    queryFn: () => fetchKpisObjetivo(user, token, objetivoId),
    enabled: !!user && !!token && !!objetivoId,
    refetchInterval: 300000,
    ...options
  });
};
